export default {
  SEARCH_MY_INVESTMENT_ADDRESS_QUERY: Symbol.for('SEARCH_MY_INVESTMENT_ADDRESS_QUERY'),
  MY_INVESTMENT_ADDRESS_REPOSITORY: Symbol.for('MY_INVESTMENT_ADDRESS_REPOSITORY'),
  MY_INVESTMENT_ADDRESS_STATE_MANAGER: Symbol.for('MY_INVESTMENT_ADDRESS_STATE_MANAGER'),
};
